import RequestHeroes from "./RequestHeroes";
import RequestDistinctFieldValues from "./RequestDistinctFieldValues";
import dayjs from "dayjs";
export default class HeroesApi {
    constructor(pageId, moduleId, apiDomain) {
        this.PageID = null;
        this.ModuleID = null;
        this.Request = null;
        this.MediaPath = null;
        this.apiDomain = null;
        this.onResult = null;
        this.PageID = pageId;
        this.ModuleID = moduleId;
        this.apiDomain = apiDomain;
        this.Request = new RequestHeroes(this.PageID, this.ModuleID);
    }
    async GetFields(fieldName) {
        const request = new RequestDistinctFieldValues(this.PageID, this.ModuleID);
        request.FieldName = fieldName;
        const payload = await this.fetch(new URL("/api/tmd/v1/DistinctFieldValuesWithDelimiter", this.apiDomain), request);
        return payload;
    }
    async Fetch() {
        const payload = await this.fetch(new URL('/api/tmd/v1/Heroes', this.apiDomain), this.Request);
        payload.data.heroes = payload.data.heroes.map((hero) => {
            if (hero.photo === "") {
                hero.photo = this.MediaPath + 'defaultprofile.svg';
            }
            hero.name = `${hero.lastName}, ${hero.firstName}`;
            hero.dateOfBirth = !hero.dateOfBirth ? null : dayjs(hero.dateOfBirth).toDate();
            hero.dateOfDeath = !hero.dateOfDeath ? null : dayjs(hero.dateOfDeath).toDate();
            hero.dateOfDischarge = !hero.dateOfDischarge ? null : dayjs(hero.dateOfDischarge).toDate();
            hero.dateOfEntry = !hero.dateOfEntry ? null : dayjs(hero.dateOfEntry).toDate();
            return hero;
        });
        if (this.onResult !== null) {
            this.onResult(payload);
        }
    }
    Update(obj, property, value) {
        if (obj === 'Filter') {
            this.updateFilter(obj, property, value);
        }
        if (obj === 'Pagination') {
            this.updatePagination(obj, property, value);
        }
    }
    OnResult(func) {
        this.onResult = func;
    }
    async fetch(url, request) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const init = {
            method: 'POST',
            headers,
            body: JSON.stringify(request)
        };
        const response = await window.fetch(url.toString(), init);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        // Not a 2xx response
        if (!(response.status >= 200 && response.status < 300)) {
            console.log(await response.text());
        }
        let payload = await response.json();
        return payload;
    }
    updateFilter(obj, property, value) {
        if (!(property in this.Request[obj])) {
            throw new Error('Property does not exist');
        }
        value = value.trim();
        if (value !== "" && this.Request[obj][property] !== value) {
            this.Request[obj][property] = value;
            this.Fetch();
        }
        if (value === "") {
            this.Request[obj][property] = null;
            this.Fetch();
        }
    }
    updatePagination(obj, property, value) {
        if (!(property in this.Request[obj])) {
            throw new Error('Property does not exist');
        }
        if (this.Request[obj][property] !== value) {
            this.Request[obj][property] = value;
            this.Fetch();
        }
    }
}
